<div class="conflict-detail-panel card">
  <div class="conflict-detail-panel__header card-header">
    <span class="conflict-detail-panel__title">&#9888; Conflict Detail - Version {{ versionName }}</span>
    <span class="conflict-detail-panel__label" *ngIf="detail">{{ totalStoresCount }} stores total</span>
  </div>

  <div class="conflict-detail-panel__body">
    <p class="conflict-detail-panel__loading" *ngIf="loading">Loading conflict details...</p>
    <p class="conflict-detail-panel__error" *ngIf="!loading && loadError">
      Could not load conflict details. Please try again.
    </p>

    <ng-container *ngIf="!loading && !loadError && detail">
      <div class="conflict-detail-panel__version-name">{{ versionName }}</div>
      <div class="conflict-detail-panel__subtitle">{{ totalStoresCount }} stores total</div>

      <ng-container *ngIf="appliedFilters.length">
        <div class="conflict-detail-panel__section-title">Active Filters Applied:</div>
        <div class="conflict-detail-panel__chips">
          <span
            *ngFor="let filter of appliedFilters"
            class="filter-tag-removable"
            [ngStyle]="getFilterChipStyle(filter)">
            {{ filter.label }}: {{ filter.displayValue }}
          </span>
        </div>
      </ng-container>

      <div class="conflict-detail-panel__columns">
        <div class="conflict-detail-panel__left" *ngIf="detail.percentBars.length">
          <div class="conflict-detail-panel__section-title">Filter Match by Attribute</div>
          <div class="match-bar-block" *ngFor="let bar of detail.percentBars">
            <div class="match-bar-block__header">
              <span class="match-bar-block__label">{{ bar.attributeName }}</span>
              <span class="match-bar-block__detail">{{ bar.percent }}% match</span>
            </div>
            <div class="match-bar">
              <div
                *ngFor="let segment of bar.segments; let i = index"
                class="match-bar__segment"
                [style.width.%]="segment.percent"
                [style.background]="getSegmentColor(bar, segment, i)"
                [style.color]="getSegmentTextColor(bar, i)"
                [matTooltip]="getSegmentTooltip(bar, segment, i)"
                matTooltipPosition="above">
                <span *ngIf="segment.percent >= 10">{{ getSegmentLabel(bar, segment, i) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="conflict-detail-panel__right"
          *ngIf="detail.breakdown.attributeColumns.length && detail.breakdown.rows.length">
          <div class="conflict-detail-panel__section-title">Store Breakdown by {{ detail.breakdown.groupBy }}</div>
          <div class="breakdown-table-scroll">
            <table class="breakdown-table">
              <thead>
                <tr>
                  <th [matTooltip]="detail.breakdown.groupBy" matTooltipPosition="above">
                    {{ detail.breakdown.groupBy }}
                  </th>
                  <th
                    *ngFor="let column of detail.breakdown.attributeColumns"
                    [matTooltip]="column"
                    matTooltipPosition="above">
                    {{ column }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let row of detail.breakdown.rows"
                  [class.breakdown-table__row--success]="getRowTone(row) === 'success'"
                  [class.breakdown-table__row--warning]="getRowTone(row) === 'warning'"
                  [class.breakdown-table__row--danger]="getRowTone(row) === 'danger'">
                  <td class="breakdown-table__group">{{ row.headerName }} ({{ row.totalCount }})</td>
                  <td *ngFor="let cell of row.cells" class="breakdown-table__cell--center">
                    {{ cell.matchedCount }}/{{ cell.totalCount }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="conflict-detail-panel__inherited" *ngIf="detail.notFilteredAttributes.length">
        <div class="conflict-detail-panel__section-title">Other Inherited Attributes (not in active filter)</div>
        <div class="conflict-detail-panel__inherited-tags">
          <span
            *ngFor="let attr of detail.notFilteredAttributes"
            class="tag"
            [ngStyle]="getCoverageChipStyle(attr)">
            {{ getCoverageLabel(attr) }}
          </span>
        </div>
      </div>

      <div class="conflict-detail-panel__actions" *ngIf="showActions">
        <button type="button" class="btn btn-outline btn-sm" (click)="onExclude()">Exclude Version</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="onIncludeAnyway()">
          Include Anyway (All {{ totalStoresCount }} stores)
        </button>
      </div>
    </ng-container>
  </div>
</div>
